import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRestartUpdate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.92688 3.38634C9.34688 3.21301 8.70688 3.09967 8.00022 3.09967C4.80688 3.09967 2.22021 5.68634 2.22021 8.87967C2.22021 12.0797 4.80688 14.6663 8.00022 14.6663C11.1935 14.6663 13.7802 12.0797 13.7802 8.88634C13.7802 7.69967 13.4202 6.59301 12.8069 5.67301M8.82688 1.33301L10.7535 3.54634L8.50688 5.18634",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRestartUpdate;
